const data = [...Array(6).keys()].map(round => 
    [...Array(8).keys()].map(pic => ({
        imgUrl: `${process.env.PUBLIC_URL}/assets/tiles/round${round + 1}/${pic + 1}.jpg`
    }))
);

export default data;